import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
  answers: ImpactCo2Answer[];
};

export const submitMultipleImpactCo2Answer = createAppAsyncThunk(
  'impactCo2/submitMultipleImpactCo2Answer',
  async (
    { projectId, answers }: Params,
    { extra: { impactCo2Gateway, snackbarGateway } },
  ) => {
    try {
      const submitMode = 'create';
      for (const answer of answers) {
        await impactCo2Gateway.submitImpactAnswer(
          projectId,
          answer,
          submitMode,
        );
      }
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(
    translate('SubmitMultipleImpactCo2Answer.Message.success'),
  );
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(
    translate('SubmitMultipleImpactCo2Answer.Message.error'),
  );
}
